import { ProductBlockCaption } from "../../../components/ProductBlockCaption/ProductBlock/components/ProductBlockDetails/components/ProductBlockCaption/ProductBlockCaption.js";
import { ProductBlockHeading } from "../../../components/ProductBlockHeading/ProductBlock/components/ProductBlockDetails/components/ProductBlockHeading/ProductBlockHeading.js";
import { ProductBlockDetails as ProductBlockDetails$1 } from "./ProductBlockDetails.js";
const ProductBlockDetails = Object.assign(ProductBlockDetails$1, {
  Caption: ProductBlockCaption,
  Heading: ProductBlockHeading
});
export {
  ProductBlockDetails
};
//# sourceMappingURL=index.js.map
